import { object, string, date } from 'yup';

export const CareDocumentRefSchema = object().shape({
  id: string().required(),
  ref: string().required(),
  createdAt: date(),
});
